import {
  ExclamationCircleOutlined,
  FileExcelOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { CommandBar, MessageBar, MessageBarType, SearchBox } from "@fluentui/react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import moment from "moment";
import {
  Button,
  DatePicker,
  Empty,
  notification,
  Skeleton,
  Tooltip,
} from "antd";
import { toJS } from "mobx";
import { Observer, observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, createContext } from "react";
import {
  Clock,
  Edit3,
  FilePlus,
  FileText,
  RefreshCcw,
  Sliders,
} from "react-feather";
import { FilterCallOut } from "../../shared/FilterCallOut";
import TargetStore from "../productiontarget/store/TargetStore";
import PreferenceStore from "../../area/home/store/preferenceStore";
import formatNumber from "accounting-js/lib/formatNumber.js";
import "../productiontarget/styles/monthtarget.css";
import confirm from "antd/lib/modal/confirm";
import ReportStore from "../../shared/ReportStore";
import { toAntPickerDate } from "../../Utility/modules/datePicker";
const targetstore = createContext(TargetStore);
const reportStoreCtx = createContext(ReportStore);

const Preferencestore = createContext(PreferenceStore);
export const TargetGrid = observer(({ assetName }) => {
  const reportStore = useContext(reportStoreCtx);
  const targetStore = useContext(targetstore);
  const preferenceStore = useContext(Preferencestore);
  const { oilValuesDecimalPlaces, gasValuesDecimalPlaces } =
    preferenceStore.preference;
  useEffect(() => {
    async function loadTargets() {
      try {
        const prompt = await targetStore.loadTargetData();
        if (prompt) {
          targetStore.showEquityDialog = true;
        }
      } catch (error) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description: error.message,
        });
      } finally {
        targetStore.isloading = false;
      }
    }
    loadTargets();
  }, [assetName, preferenceStore.preference]);

  const targetGrid = useRef(null);
  const getGridApi = () => targetGrid.current?.api;

  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: oilValuesDecimalPlaces,
        thousand: ",",
      });
    }
  };
  const formatDigitGas = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: gasValuesDecimalPlaces,
        thousand: ",",
      });
    }
  };
  const sortChanged = (e) => {
    e.api.refreshCells();
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        rowDrag: true,
        valueGetter: function (params) {
          return "";
        },
        width: 80,
        checkboxSelection: true,
        pivot: false,
      },
      {
        headerName: "PRODUCTION TARGETS",
        headerClass: "oilheader",
        children: [
          {
            headerName: "Target Year",
            field: "targetYear",
            sortable: true,
            resizable: true,
            pivot: true,
            type: "numberColumn",
            hide: true,
            width: 80,
          },
          {
            headerName: "Target Month (MM)",
            field: "targetMonthModified",
            sortable: true,
            resizable: true,

            width: 120,
            filter: true,
          },
          {
            headerName: "Number of Days",
            field: "daysInMonth",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "rgb(204,218,236)",
            },
            width: 90,
            filter: true,
          },
          {
            headerName: "Oil Produced Target(bopd)",
            field: "oilProduced",

            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Gas Produced Target(mmscf/d)",
            field: "gasProduced",

            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
          {
            headerName: "Condensate Target (bpd)",
            field: "condensateTarget",
            sortable: true,
            resizable: true,
            type: "numberColumn",
            cellStyle: { textAlign: "right" },
            width: 170,

            valueFormatter: formatDigitOil,
          },
          {
            headerName: "NGL Target (bpd)",
            field: "nglProduced",
            sortable: true,
            resizable: true,
            type: "numberColumn",
            cellStyle: { textAlign: "right" },
            width: 170,

            valueFormatter: formatDigitOil,
          },
        ],
      },
      {
        headerName: "EVACUATION TARGETS",
        headerClass: "gasprodheader",
        children: [
          {
            headerName: "OIL Received(Evacuation)Target(bopd)",
            field: "oilEvacuated",
            type: "numberColumn",
            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "GAS  Evacuation(Sales)[mmscf/d]",
            field: "gasEvacuated",
            sortable: true,
            type: "numberColumn",
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,

            valueFormatter: formatDigitGas,
          },
          {
            headerName: "Condensate  Evacuation (bpd)",
            field: "condensateEvacuated",
            sortable: true,
            resizable: true,
            type: "numberColumn",
            cellStyle: { textAlign: "right" },
            width: 170,

            valueFormatter: formatDigitOil,
          },
          {
            headerName: "NGL  Evacuation (bpd)",
            field: "nglEvacuated",
            sortable: true,
            resizable: true,
            type: "numberColumn",
            cellStyle: { textAlign: "right" },
            width: 170,

            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Comments/Remarks",
            field: "comments",
            sortable: true,
            type: "numberColumn",
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
          },
        ],
      },
      {
        headerName: "Audit",

        children: [
          {
            headerName: "Target Set By",
            field: "uploadedBy",

            sortable: true,
            resizable: true,
          },
          {
            headerName: "Target Set On",
            field: "uploadedOn",
            sortable: true,
            resizable: true,

            cellRendererFramework: function (props) {
              if (targetStore.hasImported) return null;
              return moment(props.data.uploadedOn).format(
                "ddd DD.MM.YYYY , h:mm:ss a"
              );
            },
          },
        ],
      },
    ],
  };
  const rowSelected = (grid) => {
    targetStore.disableCommand = false;
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) {
      targetStore.selRow = toJS(selrow.data);
    }
  };
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "filtert35",
                onRenderIcon: () => <FilterCallOut />,
              },
              {
                key: "access",

                text: (
                  <Tooltip title="perform quick query production and evacuation target by year">
                    Target Year{" "}
                    <DatePicker
                      picker="year"
                      defaultValue={toAntPickerDate(`01-01-${targetStore.targetYear}`, "MM-DD-YYYY")}
                      allowClear={false}
                      format={"YYYY"}
                      onChange={async (date, dateString) => {
                        try {
                          targetStore.targetYear = Number(dateString);
                          const prompt = await targetStore.loadTargetData();
                          if (prompt) {
                            targetStore.showEquityDialog = true;
                          }
                        } catch (error) {
                          notification.error({
                            key: "error",
                            message: "SPARS Feedback",
                            description: error.message,
                          });
                        }
                      }}
                    />
                  </Tooltip>
                ),

                onRenderIcon: () => <Clock className="qicon" />,
              },
              {
                key: "refresh",
                text: <Tooltip title="Refresh targets">Refresh</Tooltip>,

                onRenderIcon: () => <RefreshCcw className="qicon" />,

                onClick: async () => {
                  try {
                    await targetStore.loadTargetData();
                  } catch (error) {
                    notification.error({
                      key: "error",
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  }
                },
              },
              {
                key: "modify",
                text: (
                  <Tooltip
                    title={`Modify or edit selected production and evacuation target for ${targetStore.selRow?.targetMonthModified}`}
                  >
                    Set {targetStore.selRow?.targetMonthModified} Target
                  </Tooltip>
                ),
                disabled: targetStore.disableCommand,
                onRenderIcon: () => <Edit3 className="qicon" />,

                onClick: async () => {
                  targetStore.showTargetEditDialog = true;
                },
              },

              {
                key: "spacer9",
                onRender: () => <div style={{ width: "50px" }} />,
              },

              /*   {
                key: "fisc",

                name: "access",

                onRender: () => (
                  
                ),

                onRenderIcon: () => <Sliders className="qicon" />,
                onClick: () => {
                  //targetGrid.current.api.showNoRowsOverlay()
                },
              }, */
              {
                key: "spacer4",
                onRender: () => <div style={{ width: "50px" }} />,
              },
              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the production and evacuation target displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        getGridApi()?.setQuickFilter(searchTerms);
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
            ]}
            farItems={[
              {
                key: "Qr1",

                text: (
                  <Tooltip title="generate quick production and evacuation target reports">
                    Reports
                  </Tooltip>
                ),

                onRenderIcon: () => <FileText className="qicon" />,

                ariaLabel: "New",
                subMenuProps: {
                  items: [
                    {
                      key: "emailMessage",
                      text: "Production Target Report",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <FilePlus className="qicon" />,
                      onClick: () => {
                        reportStore.reportParameters = {
                          Asset: targetStore.mainStore.assetContextId,
                          Year: targetStore.targetYear,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.EvacuationTarget,QikReach.Reporting";
                        reportStore.headerText =
                          "Production and Evacuation Target";
                        reportStore.showReportDialog = true;
                      },
                    },
                  ],
                },
              },

              {
                key: "group4",
                disabled: !targetGrid.current?.api,

                text: (
                  <Tooltip title="Export displayed production and evacuation target to excel">
                    Export to Excel
                  </Tooltip>
                ),
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                onClick: () => {
                  const gridApi = getGridApi();

                  if (!gridApi) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "No production target data is available to export.",
                    });
                    return;
                  }

                  gridApi.exportDataAsExcel({
                    sheetName: "Targets",
                    allColumns: true,

                    skipFooters: false,
                    skipGroups: false,
                    skipHeader: false,
                    skipPinnedTop: false,
                    skipPinnedBottom: false,
                    fileName: `${targetStore.mainStore.assetContextName}_${targetStore.targetYear}_Target`,
                    skipColumnGroupHeaders: false,
                    skipColumnHeaders: false,
                    columnGroups: true,
                  });
                },
              },
            ]}
          />
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#F0F2F5",
          padding: "5px",
          width: "100%",
          height: "100px",
          margin: "10px",
        }}
      >
        <Tooltip
          title={`${assetName}-OANDO Equity Share board values last set by ${
            targetStore.ondoShare?.uploadedBy
          } on ${moment(targetStore.ondoShare?.uploadOn).format(
            "ddd DD.MM.YYYY , h:mm:ss a"
          )}`}
        >
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12"
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "#4A5568",
                }}
              >
                {`${assetName}-OANDO Equity/Share board`}
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <table
                  className="oandoshare"
                  style={{
                    width: "100%",
                    border: "1px solid #A0AEC0",
                    padding: "5px",
                  }}
                >
                  <thead>
                    <tr>
                      <th>
                        <b>Year</b>
                      </th>
                      <th>
                        <b>Equity(%)</b>
                      </th>
                      {targetStore.mainStore.assetContextId === 1 && (
                        <>
                          <td>Offshore Royalty Beniboye (%)</td>
                          <td>Onshore/Swamp Royalty (%)</td>{" "}
                          <td>Technical Adjustment(%)</td>
                        </>
                      )}
                      <th
                        style={{
                          width: "30px",
                          border: "1px solid #A0AEC0",
                          verticalAlign: "bottom",
                        }}
                      >
                        {" "}
                        <Button
                          type="primary"
                          onClick={() => {
                            confirm({
                              icon: <ExclamationCircleOutlined />,
                              content:
                                "Are you sure you want to modify equity share? this operation will be logged.",
                              onOk() {
                                targetStore.showEquityDialog = true;
                              },
                              onCancel() {
                                console.log("Cancel");
                              },
                            });
                          }}
                        >
                          Modify
                        </Button>
                      </th>
                    </tr>
                  </thead>
                  {!targetStore.prompt && (
                    <tbody>
                      <tr>
                        <td>{targetStore.ondoShare?.year}</td>
                        <td>
                          <Observer>
                            {() => (
                              <span
                                style={{ fontWeight: "bold", color: "red" }}
                              >
                                {targetStore.ondoShare?.equityShare}
                              </span>
                            )}
                          </Observer>
                        </td>
                        {targetStore.mainStore.assetContextId === 1 && (
                          <>
                            <td>
                              <Observer>
                                {() => (
                                  <span
                                    style={{ fontWeight: "bold", color: "red" }}
                                  >
                                    {targetStore.offShoreRoyalty}
                                  </span>
                                )}
                              </Observer>
                            </td>
                            <td>
                              <Observer>
                                {() => (
                                  <span
                                    style={{ fontWeight: "bold", color: "red" }}
                                  >
                                    {targetStore.onshoreRoyalty}
                                  </span>
                                )}
                              </Observer>
                            </td>{" "}
                            <td>
                              <Observer>
                                {() => (
                                  <span
                                    style={{ fontWeight: "bold", color: "red" }}
                                  >
                                    {targetStore.techAdjustment}
                                  </span>
                                )}
                              </Observer>
                            </td>
                          </>
                        )}
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </Tooltip>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          {targetStore.isloading ? (
            <>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </>
          ) : (
            <div
              className="ag-theme-balham"
              style={{
                minHeight: "50vh",
                height: "65vh",
                width: "100%",
                maxHeight: "80vh",
              }}
            >
              {targetStore.targets.size > 0 ||
              (targetStore.importHasRows && targetStore.hasImported) ? (
                <AgGridReact
                  rowData={
                    targetStore.importHasRows && targetStore.hasImported
                      ? [...targetStore.importedTargets.values()].map(
                          (target) => {
                            return {
                              ...target,
                              targetMonthModified: moment(
                                target.targetMonth,
                                "MM"
                              ).format("MMMM"),
                            };
                          }
                        )
                      : [...targetStore.targets.values()].map((target) => {
                          return {
                            ...target,
                            targetMonthModified: moment(
                              target.targetMonth,
                              "MM"
                            ).format("MMMM"),
                          };
                        })
                  }
                  ref={targetGrid}
                  sideBar={["columns", "filters"]}
                  gridOptions={{
                    defaultColDef: {
                      sortable: true,
                      filter: true,
                      enableValue: true,
                      enableRowGroup: true,
                      enablePivot: true,
                    },
                    enableCharts: true,
                    enableRangeSelection: true,

                    rowSelection: "single",
                    pagination: true,
                    columnDefs: gridcolumnDefs.columnDefs,
                    animateRows: true,
                    statusBar: {
                      statusPanels: [
                        {
                          statusPanel: "agTotalRowCountComponent",
                          align: "center",
                        },
                      ],
                    },
                    columnTypes: {
                      numberColumn: {
                        width: 130,
                        filter: "agNumberColumnFilter",
                      },
                      medalColumn: {
                        width: 100,
                        columnGroupShow: "open",
                        filter: false,
                      },
                      nonEditableColumn: { editable: false },
                      dateColumn: {
                        filter: "agDateColumnFilter",
                        filterParams: {
                          comparator: function (
                            filterLocalDateAtMidnight,
                            cellValue
                          ) {
                            var dateParts = cellValue.split("/");
                            var day = Number(dateParts[0]);
                            var month = Number(dateParts[1]) - 1;
                            var year = Number(dateParts[2]);
                            var cellDate = new Date(year, month, day);
                            if (cellDate < filterLocalDateAtMidnight) {
                              return -1;
                            } else if (cellDate > filterLocalDateAtMidnight) {
                              return 1;
                            } else {
                              return 0;
                            }
                          },
                        },
                      },
                    },
                    sideBar: {
                      defaultToolPanel: "filters",
                    },
                  }}
                  rowSelection="single"
                  onSelectionChanged={rowSelected}
                  onSortChanged={sortChanged}
                  copyHeadersToClipboard={true}
                  overlayLoadingTemplate={`${(
                    <span class="ag-overlay-loading-center">
                      Please wait while your rows are loading
                    </span>
                  )}`}
                  overlayNoRowsTemplate={
                    '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
                  }
                ></AgGridReact>
              ) : (
                <div className="ms-Grid" dir="ltr" style={{}}>
                  <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12"
                          style={{ textAlign: "center", paddingTop: "20px" }}
                        >
                          <MessageBar messageBarType={MessageBarType.warning}>This is initialized once in every fiscal year,Select <b>Target Year</b> of previous years to see the entry formats </MessageBar>
                          </div></div>
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{
                        height: "500px",
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Empty
                        description={`${targetStore.mainStore.assetContextName}-OANDO Poduction and Evacuation Targets for ${targetStore.targetYear} has not been set`}
                      />
                      <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12"
                          style={{ textAlign: "center", paddingTop: "20px" }}
                        >
                          {" "}
                          <Button
                            type="danger"
                            icon={<UploadOutlined />}
                            onClick={() => {
                              targetStore.hasImported = false;
                              targetStore.showTargetDialog = true;
                            }}
                          >
                            {`Set ${targetStore.mainStore.assetContextName}-OANDO Targets for ${targetStore.targetYear}`}
                          </Button>
                        </div>
                      </div>

                      

                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

